import { useSelector, useDispatch } from 'react-redux'
import DropdownToggle from './DropdownToggle'
import { itemsFetchData } from '../../redux/items'
import { parseSubjectsFromUrl } from '../../SearchUtils'

function CheckboxFilter({ name, title, options }) {
  const { currentFilters } = useSelector((state) => state.items)

  const dispatch = useDispatch()
  const fetchData = (filters) => dispatch(itemsFetchData({ filters }))

  const handleChange = (checkboxValue) => {
    let filter = [...((currentFilters && currentFilters[name]) || [])]
    if (filter.includes(checkboxValue)) {
      filter = filter.filter((val) => val !== checkboxValue)
    } else {
      filter.push(checkboxValue)
    }

    const newFilters = {
      popstate: 0,
      subjects: parseSubjectsFromUrl(),
      ...currentFilters,
    }
    newFilters[name] = filter
    delete newFilters.page

    fetchData(newFilters)
  }

  const filters = (currentFilters && currentFilters[name]) || []

  return (
    <div className="dropdown d-block">
      <DropdownToggle name={name} title={title} />

      <div
        className="dropdown-menu w-100 p-2"
        aria-labelledby={`dropdown-filter-${name}`}
      >
        <div>
          <label>{title}</label>
          {options.map((option) => (
            <div
              className="form-check"
              key={`checkbox-filter-${name}-${option.value}`}
            >
              <input
                type="checkbox"
                checked={filters.includes(option.value)}
                className="form-check-input"
                value={option.value}
                key={`filter-checkbox-${name}-${option.value}`}
                id={`filter-checkbox-${name}-${option.value}`}
                onChange={() => handleChange(option.value)}
              />{' '}
              <label
                className="form-check-label"
                htmlFor={`filter-checkbox-${name}-${option.value}`}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CheckboxFilter
